import { FrameName } from "../config";
import AbstractRiverTerrainTileEntity from "./AbstractRiverTerrainTileEntity";

class River7TerrainTileEntity extends AbstractRiverTerrainTileEntity {
	public static readonly frameName = FrameName.RIVER7;
}

export default River7TerrainTileEntity;
